import { h } from 'preact';
import { Route, Router, route } from 'preact-router';

import Home from '../routes/home';
import Profile from '../routes/profile';
import Products from '../routes/products';
import Articles from '../routes/articles';
import Article from '../routes/articles/article';
import Login from '../routes/login';
import Register from '../routes/signup';
import RegisterActivate from '../routes/signup/activate';
import RegisterNotify from '../routes/signup/notify';

import Kyc from '../routes/kyc';
import Fatca from '../routes/fatca';
import RiskProfile from '../routes/riskprofile';
import Logout from '../routes/logout';
import KycAddress from '../routes/kyc/address';
import KycPersonalDetails from '../routes/kyc/personal-details';
import KycFinancialProfile from '../routes/kyc/financial-profile';
import KycPep from '../routes/kyc/pep';
import KycSettlementInfo from '../routes/kyc/settlement-info';
import RouteRedirectUrl from './router/route-redirect-url';
import RouteGuard from './router/route-guard';
import RiskProfileReview from '../routes/review/risk-profile';
import KycPersonalDetailsReview from '..//routes/review/kyc/personal-details';
import KycAddressReview from '../routes/review/kyc/address';
import KycFinancialProfileReview from '../routes/review/kyc/financial-profile';
import KycPepReview from '../routes/review/kyc/pep';
import KycSettlementInfoReview from '../routes/review/kyc/settlement-info';
import FatcaReview from '../routes/review/fatca';
import KycPersonalInfoReview from '../routes/review/kyc/personal-info';
import ProfileChangePassword from '../routes/profile/change-password';
import { getCsrf } from '../controllers/fetch';
import { GlobalState } from '../states/global-state';
import PageRouter from '../routes/page-router';
import AboutUsPage from '../routes/about-us';
import FaqPage from '../routes/faq';
import ContactPage from '../routes/contact';
import ForgotPassword from '../routes/forgot-password';
import ForgotPasswordVerify from '../routes/forgot-password-verify';

const CustomRouter = () => {
  const handleRoute = async e => {
    //e.url
    GlobalState.currentPage.value = e;
    getCsrf();
  };

  return (
    <Router onChange={handleRoute}>
      <Route path="/" component={PageRouter} guarded={false} />
      <Route path="/home" component={Home} />
      <Route path="/login" component={Login} />
      <Route path="/forgot-password" component={ForgotPassword} />
      <Route path="/forgot-password-verify" component={ForgotPasswordVerify} />
      <Route path="/articles" component={Articles} />
      <Route path="/articles/:id" component={Article} />
      <RouteGuard path="/profile" component={Profile} user="me" />
      <RouteGuard
        path="/profile/change-password"
        component={ProfileChangePassword}
      />

      <Route path="/products" component={Products} />
      <Route path="/support/faq" component={FaqPage} />
      <Route path="/support/contact" component={ContactPage} />
      <Route path="/about" component={AboutUsPage} />

      <Route path="/logout/:token?" component={Logout} />

      <Route path="/signup/activate" component={RegisterActivate} />
      <Route path="/signup/activate/:email" component={RegisterActivate} />
      <Route path="/signup/notify" component={RegisterNotify} />
      <Route path="/signup" component={Register} />
      <RouteGuard path="/kyc" component={Kyc} />
      <RouteGuard path="/kyc/personal-info" component={Kyc} />
      <RouteGuard path="/kyc/address" component={KycAddress} />
      <RouteGuard path="/kyc/personal-details" component={KycPersonalDetails} />
      <RouteGuard
        path="/kyc/financial-profile"
        component={KycFinancialProfile}
      />
      <RouteGuard path="/kyc/pep" component={KycPep} />
      <RouteGuard path="/kyc/settlement-info" component={KycSettlementInfo} />

      <RouteGuard path="/fatca" component={Fatca} />
      <RouteGuard path="/riskprofile" component={RiskProfile} />
      <RouteGuard path="/review" component={KycPersonalInfoReview} />
      <RouteGuard path="/review/riskprofile" component={RiskProfileReview} />
      <RouteGuard path="/review/fatca" component={FatcaReview} />
      <RouteGuard path="/review/kyc" component={KycPersonalInfoReview} />
      <RouteGuard
        path="/review/kyc/personal-info"
        component={KycPersonalDetailsReview}
      />
      <RouteGuard path="/review/kyc/address" component={KycAddressReview} />
      <RouteGuard
        path="/review/kyc/personal-details"
        component={KycPersonalDetailsReview}
      />
      <RouteGuard
        path="/review/kyc/financial-profile"
        component={KycFinancialProfileReview}
      />
      <RouteGuard path="/review/kyc/pep" component={KycPepReview} />
      <RouteGuard
        path="/review/kyc/settlement-info"
        component={KycSettlementInfoReview}
      />

      <RouteRedirectUrl
        path="/redirect/dashboard"
        to={`${location.origin}/dashboard#?redirect=%2Fdashboard%2Fpera`}
      />
      <RouteRedirectUrl
        path="/redirect/cart"
        to={`${location.origin}/dashboard#?redirect=%2Fcart`}
      />
      <RouteRedirectUrl
        path="/redirect/pera/packages"
        to={`${location.origin}/dashboard#?redirect=%2Fpera%2Fpackages`}
      />

      {/* <RouteRedirectUrl
        path="/dashboard"
        to="https://pera-revamp-uat.seedbox.ph/#"
      />
      <RouteRedirectUrl
        path="/cart"
        to="https://pera-revamp-uat.seedbox.ph/#?path=%2Fcart"
      /> */}
    </Router>
  );
};

export default CustomRouter;

export function page(path, callback) {
  const page = window['page'];
  if (page) {
    return page(path, callback);
  }
  return null;
}
